export default "__VITE_ASSET__1acb639f__"